import { useEffect } from 'react';
import cn from 'classnames';
import { Grid } from 'ht-styleguide';

/* Client Store */
import { useResponsiveIsMobileOrTablet } from '@store/client/store.responsive';

/* Components */
import PromoBlocks from '@components/Searchbar/Results/PromoBlocks';
import EmptyState from '@components/EmptyState';
import CategoryResults from '@components/Searchbar/Results/CategoryResults';
import ServiceResults from '@components/Searchbar/Results/ServiceResults';
import QuickLinks from '@components/Searchbar/Results/QuickLinks';

/* Constants */
import { DEFAULT_TEXTS } from 'src/components/Searchbar/constants';

/* Styles */
import styles from './hero.module.scss';

import { HERO_RESULTS_ID, SEARCH_ICON } from '@components/Searchbar/Hero/hero.constants';

type THeroSearchResults = {
  scoredResults: $FixMe;
  productResults: $FixMe;
  serviceResults: $FixMe;
  getItemProps: $FixMe;
  searchTerm: string;
  iconClick: BaseAnyFunction;
  activeSearch: boolean;
};

const HomepageSearchResults = ({
  serviceResults,
  productResults,
  scoredResults,
  searchTerm,
  activeSearch,
  iconClick,
  getItemProps,
  ...props
}: THeroSearchResults) => {
  /* Client State */
  const isMobileOrTablet = useResponsiveIsMobileOrTablet();

  const resultsStyles = !searchTerm ? styles.noSearchTerm : styles.autoComplete;
  const rawResults = searchTerm ? scoredResults : [];

  useEffect(() => {
    const element = document.getElementById(HERO_RESULTS_ID);

    if (searchTerm && isMobileOrTablet) {
      const yOffset = -144; // from top of results to top of input + offset from top of the page.
      const yPosition = (element && element.getBoundingClientRect().top + window.pageYOffset + yOffset) || 0;
      window.scrollTo({
        top: yPosition,
        behavior: 'smooth',
      });
    }
  }, [searchTerm, isMobileOrTablet]);
  const results =
    Array.isArray(rawResults) && rawResults.length ? (
      <>
        <ServiceResults getItemProps={getItemProps} serviceResults={serviceResults} searchTerm={searchTerm} iconClick={iconClick} {...props} />
      </>
    ) : (
      searchTerm && (
        <>
          <EmptyState
            className={cn('paddingY-medium')}
            iconName={SEARCH_ICON}
            title={DEFAULT_TEXTS.EMPTY_STATE.title}
            additionalTitle={searchTerm}
            text={DEFAULT_TEXTS.EMPTY_STATE.text}
          />
          <QuickLinks iconClick={iconClick} searchTerm={searchTerm} />
        </>
      )
    );

  return activeSearch ? (
    <div id={HERO_RESULTS_ID}>
      <Grid.FullWidth classes={styles.gridContainer}>
        <Grid.Row classes={resultsStyles}>
          <Grid.Column sm={4} md={8} lg={12} classes={cn('marginBottom-medium', styles.column)}>
            {results}
          </Grid.Column>
          {searchTerm && (
            <>
              <Grid.Column sm={4} md={8} lg={12} classes={styles.blockColumn}>
                <PromoBlocks iconClick={() => iconClick} searchTerm={searchTerm} />
              </Grid.Column>
              <Grid.Column sm={4} md={8} lg={12}>
                {!rawResults.length && <CategoryResults scoredResults={scoredResults} searchTerm={searchTerm} iconClick={iconClick} {...props} />}
              </Grid.Column>
            </>
          )}
        </Grid.Row>
      </Grid.FullWidth>
    </div>
  ) : null;
};

export default HomepageSearchResults;
